export default class GenericShowHide {
  domRoot: any;
  params: any;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = params;
    this.init();
  }

  init() {
    let togglerElements = Array.from(document.getElementsByClassName(this.params.showHideClass)) as HTMLElement[];
    togglerElements.forEach(element => {
      if (this.params.toggleBehavior == "fade") {
        element.style.transition = "opacity 500ms";
      } else if (this.params.toggleBehavior == "rollup") {
        element.style.transition = "max-height 500ms";
        if (element.classList.contains('toggle-hide')) {
          element.style.overflow = "hidden";
          element.style.maxHeight = "0";
        }
      }
    });

    let showHideToggler = this.domRoot.querySelector(".show-hide-toggler") as HTMLElement;
    showHideToggler.addEventListener("click", (e) => {
      e.preventDefault();
      let togglerText = showHideToggler.innerText.trim();
      togglerElements.forEach(element => {
        if (element.classList.contains('toggle-hide')) {
          element.classList.toggle("toggle-hide");
          element.style.maxHeight = "500px";
          // @ts-ignore
          element.style.opacity = 1;
          setTimeout(function() {
            element.style.maxHeight = "none";
            element.style.overflow = "auto";
          }, 500);
        } else {
          if (this.params.toggleBehavior == "fade") {
            // @ts-ignore
            element.style.opacity = 0;
          } else if (this.params.toggleBehavior == "rollup") {
            element.style.maxHeight = "500px";
            element.style.overflow = "hidden";
            setTimeout(function() {
              // @ts-ignore
              element.style.maxHeight = 0;
            }, 50);
          }
          setTimeout(function() {
            element.classList.toggle("toggle-hide");
          }, 500);
        }
      });
      setTimeout(function() {
        e.target.innerText = togglerText == showHideToggler.getAttribute("data-showtext") ? showHideToggler.getAttribute("data-hidetext") : showHideToggler.getAttribute("data-showtext");
        e.target.classList.toggle('hide-button-toggled');
      }, 500);
    });
  }
}
